<template>
  <b-row>
    <b-col cols="12">
      <input-select-search
        ref="tiposAditivo"
        :label="$t(`ACADEMICO.TIPO_ADITIVO`)"
        :options="opcoes.tipoAditivos"
        v-model="form.tipoAditivoContrato"
        required
      />
    </b-col>

    <b-col cols="12">
      <input-editor-text
        ref="motivo"
        :label="$t(`ACADEMICO.DETALHES_DO_MOTIVO`)"
        :value="form.motivo"
        v-model="form.motivo"
      />
    </b-col>
  </b-row>
</template>

<script>
import { InputSelectSearch, InputEditorText } from '@/components/inputs';
import EnumeradoresService from '@/common/services/enumeradores/enumeradores.service';
import mensagem from '@/common/utils/mensagem';
import { START_LOADING, STOP_LOADING } from '@/store/Store';

export default {
  components: {
    InputSelectSearch,
    InputEditorText,
  },
  props: {
    form: { type: Object, default: Object },
  },
  data() {
    return {
      opcoes: {
        tipoAditivos: [],
      }
    }
  },
  mounted() {
    this.pegarTiposAditivo()
  },
  methods: {
    pegarTiposAditivo() {
      this.$store.dispatch(START_LOADING);
      EnumeradoresService.listar('tipos-aditivos-contrato')
        .then(({ data }) => {
          data = data.map((row) => ({
            ...row,
            value: row.id,
            text: row.descricao,
          }));
          this.opcoes.tipoAditivos = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
  }
};
</script>
